export const customerPaymentStrings = {
  evidenceColumn: "Evidencia",
  contractColumn: "Contrato",
  attachEvidenceLabel: "Comprobante (imagen o PDF, opcional)",
  attachContractLabel: "Contrato (imagen o PDF, obligatorio)",
  chooseEvidenceFile: "Elegir archivo",
  chooseContractFile: "Elegir contrato",
  previewDialogTitle: "Archivo de pago",
  previewContractTitle: "Contrato",
  evidenceLoadError: "No se pudo cargar el archivo.",
  previewEvidenceAria: "Ver comprobante",
  previewContractAria: "Ver contrato",
  noEvidenceDash: "—",
  closePreviewDialog: "Cerrar",
  createDownPaymentTitle: "Registrar separación (enganche)",
  addFeeTitle: "Registrar abono",
  lotNumberLabel: "Número de lote",
  expectedValueLabel: "Valor de separación",
  firstPaymentLabel: "Primer abono",
  feePaymentLabel: "Valor del abono",
  historyTitle: "Separaciones y abonos",
  statusPending: "Pendiente",
  statusCompleted: "Completada",
  remainingLabel: "Restante",
  paidLabel: "Pagado",
  expectedLabel: "Esperado",
  onePerProjectHint:
    "Solo una separación por proyecto. Después solo se registran abonos hasta completar el valor.",
  pendingFeesOnlyHint:
    "Ya existe una separación para este proyecto. Registra abonos hasta completar el valor.",
  completedBanner: "Separación completada para este proyecto. No se pueden agregar más abonos.",
} as const
